module.exports = __webpack_public_path__ + "img/news3.954cbcbd.jpg";